import { VETLINES_SECTION } from "../../constants";
import { VetlineMain1 } from "../../assets";

export default function VetlinesSection() {
    return (
        <div className="sm:py-12 py-6 border-b border-neutral-300 sm:px-16 px-6">
            <div className="flex md:flex-row flex-col gap-8 items-center">
                <div className="flex justify-center items-center">
                    <img
                        src={VETLINES_SECTION.image}
                        alt={VETLINES_SECTION.brand}
                        className="rounded-2xl object-contain max-w-[400px] max-h-[400px] w-auto h-auto"
                    />
                </div>

                <div className="flex-1 text-center md:text-left">
                    <p className="text-emerald-500 font-poppins font-semibold text-sm uppercase tracking-wide">
                        {VETLINES_SECTION.brand} · {VETLINES_SECTION.origin}
                    </p>
                    <h2 className="font-poppins font-bold md:text-[36px] xs:text-[28px] text-[22px] mt-2">
                        {VETLINES_SECTION.title}
                    </h2>
                    <p className="italic font-semibold text-neutral-600 mt-2">
                        {VETLINES_SECTION.subtitle}
                    </p>
                    <p className="mt-4 text-neutral-700">{VETLINES_SECTION.description}</p>

                    <ul className="mt-4 space-y-1 text-left inline-block">
                        {VETLINES_SECTION.benefits.map((b) => (
                            <li key={b} className="text-sm text-neutral-700">
                                ✓ {b}
                            </li>
                        ))}
                    </ul>

                    <div className="mt-4 flex flex-wrap gap-2 justify-center md:justify-start">
                        <span className="text-xs bg-green-100 text-emerald-800 rounded-full px-3 py-1">
                            {VETLINES_SECTION.exportedTo}
                        </span>
                        <span className="text-xs bg-green-100 text-emerald-800 rounded-full px-3 py-1">
                            Distributed by {VETLINES_SECTION.distributedBy}
                        </span>
                    </div>

                    <p className="mt-4 font-poppins font-semibold text-emerald-600">
                        {VETLINES_SECTION.tagline}
                    </p>

                    <a
                        href={`tel:${VETLINES_SECTION.cta.phone.replace(/\s/g, "")}`}
                        className="inline-block mt-4 bg-emerald-600 text-white rounded-md px-5 py-2 font-poppins font-semibold hover:bg-emerald-700 transition"
                    >
                        {VETLINES_SECTION.cta.text}: {VETLINES_SECTION.cta.phone}
                    </a>
                </div>
            </div>
        </div>
    );
}